/// Generated by expo-google-fonts/generator
/// Do not edit by hand unless you know what you are doing
///

export { useFonts } from './useFonts';

export { default as __metadata__ } from './metadata.json';
export const Montserrat_100Thin = require('./Montserrat_100Thin.ttf');
export const Montserrat_200ExtraLight = require('./Montserrat_200ExtraLight.ttf');
export const Montserrat_300Light = require('./Montserrat_300Light.ttf');
export const Montserrat_400Regular = require('./Montserrat_400Regular.ttf');
export const Montserrat_500Medium = require('./Montserrat_500Medium.ttf');
export const Montserrat_600SemiBold = require('./Montserrat_600SemiBold.ttf');
export const Montserrat_700Bold = require('./Montserrat_700Bold.ttf');
export const Montserrat_800ExtraBold = require('./Montserrat_800ExtraBold.ttf');
export const Montserrat_900Black = require('./Montserrat_900Black.ttf');
export const Montserrat_100Thin_Italic = require('./Montserrat_100Thin_Italic.ttf');
export const Montserrat_200ExtraLight_Italic = require('./Montserrat_200ExtraLight_Italic.ttf');
export const Montserrat_300Light_Italic = require('./Montserrat_300Light_Italic.ttf');
export const Montserrat_400Regular_Italic = require('./Montserrat_400Regular_Italic.ttf');
export const Montserrat_500Medium_Italic = require('./Montserrat_500Medium_Italic.ttf');
export const Montserrat_600SemiBold_Italic = require('./Montserrat_600SemiBold_Italic.ttf');
export const Montserrat_700Bold_Italic = require('./Montserrat_700Bold_Italic.ttf');
export const Montserrat_800ExtraBold_Italic = require('./Montserrat_800ExtraBold_Italic.ttf');
export const Montserrat_900Black_Italic = require('./Montserrat_900Black_Italic.ttf');
